function u(r) {
  return (r == null ? void 0 : r.options) !== void 0;
}
function e(r) {
  return r[0] ? u(r[0]) : !1;
}
export {
  u as isGroup,
  e as isGroups
};
